import { create } from 'zustand';

interface ParticipantsStore {
  culpritStoreId: number | null;
  setCulpritStoreId: (data: number) => void;
  clearCulpritStoreId: () => void;
}
export const useParticipantsStore = create<ParticipantsStore>((set) => ({
  culpritStoreId: null,
  setCulpritStoreId: (data) => set({ culpritStoreId: data }),
  clearCulpritStoreId: () => set({ culpritStoreId: null }),
}));
